import Cookies from "js-cookie";

// One place that writes the session cookie, so every login/refresh uses the same safe options:
// expires with the server-side session (30 days), never sent on cross-site requests, HTTPS-only when the site is on HTTPS.
// (The app sends the token itself in each request, so the browser never attaches this cookie automatically.)
export function setSessionCookie(token) {
  Cookies.set("session", token, {
    expires: 30,
    sameSite: "strict",
    secure: typeof window !== "undefined" && window.location.protocol === "https:",
  });
}
